<template>
  <div>
    <el-dialog
      :title="'绑定网元'"
      :visible="selectnet"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="netClose"
      width="70%">
      <el-form>
        <div v-for="(data, initDataIdx) in initDataArray">
          <el-row style="margin-bottom: 20px;">
            <el-col :span="7">
              <el-form-item label="业务类型">
                <el-select v-model="data.taskType" placeholder="请选择" @change="businessChange(initDataIdx)"
                           style="width: 160px;">
                  <el-option v-for="(option, idx) in moduleTypeList"
                             :key="option.BusinessType"
                             :label="option.BusinessName"
                             :value="option.BusinessType"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7" style="margin-left:6px;">
              <el-form-item label="模块类型">
                <el-select v-model="data.moduleType" style="width: 160px;" placeholder="请选择"
                           @change="getsourceList(initDataIdx)">
                  <el-option v-for="(option, idx) in data.serverType"
                             :key="idx"
                             :disabled="option.show"
                             :label="option.type"
                             :value="option.type"></el-option>
                  <!--                  <el-option v-for="(option, idx) in newSelectType"-->
                  <!--                             :disabled="option.show"-->
                  <!--                             :key="idx"-->
                  <!--                             :label="option.type"-->
                  <!--                             :value="option.type"></el-option>-->
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="primary" @click="addOption()" style="margin-left: 10px;"
                         icon="el-icon-circle-plus-outline"></el-button>
              <el-button v-if="initDataIdx>0" type="warning" @click="delOption(initDataIdx)" style="margin-left: 10px;"
                         icon="el-icon-remove-outline"></el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              :span="6"
              v-for="(item, index) in data.instanceData"
              :key="item.id"
              style="margin-bottom:40px;width: 25%;">
              <div @click="handleCheckedChange(item, index, $event)">
                <!--              :class="{active:item.checkedHis}"-->
                <el-card
                  :body-style="{ padding: '0px'}"
                  :class="[{active:item.checkedHis}]"
                  shadow="hover"
                  :offset="1"
                  :disabled="flag"
                  style="margin-left:10px;width: 220px;height: 100%;cursor:pointer;">
                  <InstanceComponent :item="item"/>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </div>
        <el-row style="text-align:center;">
          <el-button type="primary" @click="savenetArray()">确定</el-button>
          <el-button @click="resetForm()">取消</el-button>
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import InstanceComponent from './InstanceComponent.vue'

  export default {
    name: "SelectNetElement",
    components: {InstanceComponent},
    data() {
      return {
        active: null,
        current: {},
        taskType: "",
        moduleType: "",
        deviceArray: [], //设备列表
        search: "",
        //instanceData: [],
        BusinessTypeInfo: [],
        moduleTypeList: [],
        serverType: [],
        initDataArray: [],
        selectedNodeId: [],
        flag: "",
        // banFlag: false,
        selectModuleType: "",
        selectedModule: "",
        newType: [],
        // newSelectType: [],
        newSelectArrs: [],
        businessArr: [],
        totalArr: [],
        totalObj: {},
        flagIdx: ""
      }
    },
    computed: {},
    methods: {
      netClose() {
        this.$emit('editCallback', false)
        // this.selectnet=false
      },
      initData() {
        let data = {
          "projectSourceId": this.groupObject.groupuuid
        };
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          background: 'rgba(55, 55, 55, 0.4)'
        });
        let _this = this;
        _this.initDataArray = []
        this.$axios.post(this.baseUrl3 + 'management3/source/getManagement2CheckedSource', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              let map = new Map();
              let mapserverType = new Map();
              for (let i = 0; i < _this.moduleTypeList.length; i++) {
                let serverType = [];
                _this.moduleTypeList[i].ServerType.forEach(e => {
                  let newTypeObj = {
                    show: false,
                    type: e
                  };
                  serverType.push(newTypeObj);
                });
                if (_this.moduleTypeList[i].BusinessType == 1) {
                  map.set("1", "聚合")

                  mapserverType.set("1", serverType)
                } else if (_this.moduleTypeList[i].BusinessType == 2) {
                  map.set("2", "会议")

                  mapserverType.set("2", serverType)
                }
              }
              let array = []
              for (var key in data) {
                let valueArray = data[key]
                // let BusinessName = "";
                if (valueArray && valueArray.length > 0) {
                  for (let j = 0; j < valueArray.length; j++) {
                    let obj = {
                      taskType: Number(valueArray[j].taskType),
                      moduleType: key
                    }
                    array.push(obj)
                  }
                }
              }
              let _array = _this.deteleObject(array)
              for (let j = 0; j < _array.length; j++) {
                _this.initDataArray.push({
                  taskType: Number(_array[j].taskType),
                  moduleType: _array[j].moduleType,
                  serverType: mapserverType.get(_array[j].taskType + ""),
                  instanceData: []
                })
              }

              for (let j = 0; j < _this.initDataArray.length; j++) {
                _this.getsourceList(j);
              }
              if (_this.initDataArray.length == 0) {
                let obj = {
                  taskType: "",
                  moduleType: "",
                  serverType: [],
                  instanceData: []
                }
                _this.initDataArray.push(obj)
              }
              loading.close();
            } else {
              loading.close();
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            loading.close();
          })
      },
      deteleObject(obj) {
        var uniques = [];
        var stringify = {};
        for (var i = 0; i < obj.length; i++) {
          var keys = Object.keys(obj[i]);
          keys.sort(function (a, b) {
            return (Number(a) - Number(b));
          });
          var str = '';
          for (var j = 0; j < keys.length; j++) {
            str += JSON.stringify(keys[j]);
            str += JSON.stringify(obj[i][keys[j]]);
          }
          if (!stringify.hasOwnProperty(str)) {
            uniques.push(obj[i]);
            stringify[str] = true;
          }
        }
        uniques = uniques;
        return uniques;
      },
      addOption() {
        let obj = {
          taskType: "",
          moduleType: "",
          instanceData: []
        };
        this.initDataArray.push(obj);
        // this.banFlag = true
      },
      delOption(idx) {
        this.initDataArray.splice(idx, 1);
        this.totalArr.splice(idx, 1);
        this.changeSelect();
      },
      resetForm(val) {
        this.$emit('editCallback', val)
      },
      getsourceList(idx) {
        let _this = this;
        let obj = _this.initDataArray[idx];
        this.businessArr = obj.taskType;
        this.selectModuleType = obj.moduleType;
        if(_this.totalArr.length > idx){
          let tmpObj = _this.totalArr[idx];
          tmpObj.moduleList =obj.moduleType
        }else {
          this.totalObj = {
            type: this.businessArr,
            moduleList: this.selectModuleType
          };
          this.totalArr.push(this.totalObj);
        }

        let data = {
          'pageNo': this.currentPage,
          'pageSize': this.pageSize,
          'moduleType': obj.moduleType,
          'projectSourceId': this.groupObject.groupuuid,
          'taskType': obj.taskType + ""
        };
        obj.instanceData = [];


        this.$axios.post(this.baseUrl3 + 'management3/source/getManagement2Source', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.changeSelect();
              obj.instanceData = data;
              //this.getNewTotal()
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleCheckedChange(row, index, e) {
        // this.active = index;
        // this.current = row
        // row.checkedHis = !row.checkedHis;
        let _this = this;
        let flag = true;
        for (let i = 0; i < _this.initDataArray.length; i++) {
          let obj = _this.initDataArray[i];
          if (obj.instanceData && obj.instanceData.length > 0) {
            for (let i = 0; i < obj.instanceData.length; i++) {
              if (obj.instanceData[i].checkedHis) {
                if (obj.instanceData[i].nodeId == row.nodeId) {
                  flag = false;
                  if (row.checkedHis == false) {
                    this.$message.error('该业务ID已选中其他实例！')
                  }
                }
              }
            }
          }
        }
        if (flag) {
          row.checkedHis = true;
        } else {
          row.checkedHis = false;
        }
      },
      savenetArray() {
        let _this = this;
        let paramArray = [];

        for (let i = 0; i < _this.initDataArray.length; i++) {
          let obj = _this.initDataArray[i]
          let instanceNode = []
          if (obj.instanceData && obj.instanceData.length > 0) {
            for (let i = 0; i < obj.instanceData.length; i++) {
              if (obj.instanceData[i].checkedHis) {
                instanceNode.push({
                  instanceId: obj.instanceData[i].instanceId,
                  nodeId: obj.instanceData[i].nodeId,
                })
              }
            }
            if (instanceNode.length > 0) {
              paramArray.push({
                'taskType': obj.taskType + "",
                'moduleType': obj.moduleType,
                "projectSourceId": this.groupObject.groupuuid,
                "instanceNode": instanceNode,
              })
            }
          }

        }
        let paramObj = {
          "projectSourceId": this.groupObject.groupuuid,
          "modules": paramArray
        }
        _this.savenet(paramObj);

      },
      //保存所绑定的网元
      savenet(array) {
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55,55, 55, 0.4)'
        });
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/source/BindModules', array)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              _this.$emit('editCallback', true);
              _this.$message.success("操作成功！");
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err)
            setTimeout(() => {
              loading.close();
            }, 2000);
          })
      },
      initNetList() {
        let _this = this;
        _this.moduleTypeList = []
        this.$axios.get(this.baseUrl3 + 'management3/config/generatebusinesstype')
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              for (let i = 0; i < data.BusinessTypeInfo.length; i++) {
                if (data.BusinessTypeInfo[i].BusinessType == 1) {
                  data.BusinessTypeInfo[i].BusinessName = "聚合"
                } else if (data.BusinessTypeInfo[i].BusinessType == 2) {
                  data.BusinessTypeInfo[i].BusinessName = "会议"
                }
              }
              _this.moduleTypeList = data.BusinessTypeInfo;
              _this.initData();
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'})
              console.log(msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      changeSelect() {
        let _this = this;
        for (let j = 0; j < _this.initDataArray.length; j++) {
          let obj = _this.initDataArray[j];
            for (let i = 0; i < obj.serverType.length; i++) {
              for (let k = 0; k < _this.totalArr.length; k++) {
                if( obj.taskType == _this.totalArr[k].type ){
                  if(obj.serverType[i].type == _this.totalArr[k].moduleList){
                    obj.serverType[i].show = true;
                    break;
                  }else {
                    obj.serverType[i].show = false;
                  }
                }
              }
            }
        }
      },
      businessChange(idx) {
        this.flagIdx = idx;
        this.serverType = [];
        let _this = this;
        let obj = _this.initDataArray[idx];
        if(_this.totalArr.length > idx){
          let tmpObj = _this.totalArr[idx];
          tmpObj.type =obj.taskType;
          tmpObj.moduleList = '';
        }

        obj.moduleType = "";
        obj.instanceData = [];
        let tkType = obj.taskType;//1聚合，2会议
        this.businessArr = obj.taskType;//1聚合，2会议

        for (let i = 0; i < _this.moduleTypeList.length; i++) {
          if (tkType == _this.moduleTypeList[i].BusinessType) {
            let serverType = [];
            _this.moduleTypeList[i].ServerType.forEach(e => {
              let newTypeObj = {
                show: false,
                type: e
              };
              serverType.push(newTypeObj);
            });
            _this.$set(obj, 'serverType', serverType);

          }
        }

        // this.totalArr.forEach(e => {
        //   if (e.type == this.businessArr) {
        //     this.serverType.forEach(val => {
        //       if (val.type == e.moduleList) {
        //         val.show = true;
        //       }
        //     })
        //   }
        // });
        this.changeSelect();
        //return this.serverType
      }
    },
    props: {
      selectnet: {
        type: Boolean
      },
      groupObject: {
        type: Object
      }
    },
    created() {
      this.initNetList();
    }
  }
</script>

<style scoped>
  .el-loading-spinner {
    background-image: url('../../../assets/loading1.svg');
    background-size: 63px 100px;
    background-repeat: no-repeat;
    height: 30%;
    background-position: center;
    top: 200px;
  }

  .el-loading-spinner .circular {
    display: none;
  }

  .el-loading-spinner .el-loading-text {
    margin-top: 150px;
    text-align: center;
  }

  .active {
    background-color: #409eff !important;
    border-color: #409eff !important;
  }

  .flag {
    background-color: #ff752d;
    border-color: #ff752d;
  }
</style>
